<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header text-center">
          <i class="fas fas-align-justify"></i>
          <h3>Template Details</h3>
          <div class="row justify-content-center">
            <div class="col-10">
              <div class="card">
                <div class="card-body text-center">
                  <div class="col-9 mx-auto text-center">
                    <h5 class="card-title">Template Name:  {{ template?.name }}</h5>
                    <p class="card-text fst-italic mt-3 side-view-label">Side View:</p>
                    <img class="card-img-bottom img-fluid mb-2" [src]="template?.templateWithKeyUrl" alt="">
                    <p class="card-text fst-italic overhead-view-label">Overhead View:</p>
                    <img class="card-img-bottom img-fluid" [src]="template?.overheadImageUrl" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form [formGroup]="quoteForm" class="needs-validation mt-4" novalidate>
            <div class="row mb-3 justify-content-center">
              <ng-container formArrayName="measurements">
                <div class="col-xs-6 col-md-3" *ngFor="let measurement of measurements; index as i" [formGroupName]="i">
                  <div class="d-flex gap-2">
                    <div class="flex-grow-1">
                      <label class="custom-control-label d-block pt8" for="{{i}}">{{ getLabel(i) }}</label>
                      <input [name]="'Measurement ' + getLetter(i)" [formControlName]="'measurement'" id="{{i}}"
                             [type]="'number'" [required]="true"
                             [class]="'form-control'">
                    </div>
                    <!--                    <div class="col-auto d-flex align-self-end">-->
                    <!--                      <div class="vr"></div>-->
                    <!--                    </div>-->
                  </div>
                </div>
              </ng-container>

              <!-- Skirted checkboxes and caravan height continue in the same row -->
              <div class="col-xs-12 col-md-1 d-flex flex-column align-items-start align-items-center pt8">
                <label class="custom-control-label d-block" for="deckSkirted">Deck Skirted</label>
                <input [formControlName]="'deckSkirted'" id="deckSkirted"
                       type="checkbox"
                       class="form-check-input mt-1">
              </div>
              <div class="col-xs-12 col-md-2 d-flex flex-column align-items-start align-items-center pt8">
                <label class="custom-control-label d-block" for="caravanSkirted">Caravan Skirted</label>
                <input [formControlName]="'caravanSkirted'" id="caravanSkirted"
                       type="checkbox"
                       class="form-check-input mt-1">
              </div>
              <div class="col-xs-12 col-md-3">
                <labeled-input [name]="'Height of deck (ft)'" [formName]="'caravanHeight'"
                               [form]="quoteForm" [type]="'number'" [required]="true"
                               ngbTooltip="Enter the height of the deck will be from the ground in feet"
                               [class]="'form-control'" placeholder="2"></labeled-input>
              </div>
            </div>
            <hr/>
            <!-- Row 1 -->
            <div class="row g-3">
              <div class="col-xs-6 col-md-3">
                <label class="col-form-label d-block">Deck Colour
                  <ng-select
                    [items]="deckColours"
                    bindLabel="text"
                    bindValue="text"
                    [appearance]="'outline'"
                    formControlName="deckColour"
                    [required]="true">
                  </ng-select>
                </label>
              </div>
              <div class="col-xs-6 col-md-3">
                <label class="col-form-label d-block">Balustrade Colour
                  <ng-select
                    [items]="balustradeColours"
                    bindLabel="text"
                    bindValue="text"
                    [appearance]="'outline'"
                    formControlName="balustradeColour"
                    [required]="true">
                  </ng-select>
                </label>
              </div>
              <!-- Row 2 -->
              <div class="col-xs-12 col-md-2">
                <labeled-input [name]="'Number Of Hatches'" [formName]="'numberOfHatches'"
                               [form]="quoteForm" [type]="'number'" [required]="true"
                               [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-xs-12 col-md-2">
                <labeled-input [name]="'Number Of Gates'" [formName]="'numberOfGates'"
                               [form]="quoteForm" [type]="'number'" [required]="true"
                               [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-xs-12 col-md-2">
                <labeled-input [name]="'Sets Of Steps'" [formName]="'numberOfStepSets'"
                               [form]="quoteForm" [type]="'number'" [required]="true"
                               [class]="'form-control'"></labeled-input>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-xs-12 col-md-3">
                <label class="col-form-label d-block">Park
                  <ng-select
                    [items]="parks"
                    bindLabel="custName"
                    bindValue="id"
                    [appearance]="'outline'"
                    formControlName="customerId"
                    [required]="true">
                  </ng-select>
                </label>
              </div>
              <div class="col-xs-12 col-md-2">
                <labeled-input [required]="true" [name]="'Plot'" [formName]="'plot'"
                               [form]="quoteForm" [type]="'text'" [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-xs-12 col-md-3">
                <labeled-input [required]="true" [name]="'Customer Name'"
                               [formName]="'customerName'" [form]="quoteForm" [type]="'text'"
                               [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-xs-12 col-md-2">
                <labeled-input [required]="true" [name]="'Customer Email'"
                               [formName]="'customerEmail'" [form]="quoteForm" [type]="'text'"
                               [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-xs-12 col-md-2">
                <labeled-input [required]="true" [name]="'Phone'"
                               [formName]="'customerPhone'" [form]="quoteForm" [type]="'text'"
                               [class]="'form-control'"></labeled-input>
              </div>
            </div>
            <hr/>
            <div class="row g-3">
              <div class="col">
                <labeled-input [name]="'Comments'" [formName]="'comments'"
                               [form]="quoteForm" [type]="'text'" [class]="'form-control'"></labeled-input>
              </div>
            </div>

            <!-- Button -->
            <div class="row">
              <div class="col d-flex justify-content-end">
                <button type="button" class="btn btn-success"
                        [swal]="{title: 'Prices could change when survey is carried out', showDenyButton: true}"
                        (confirm)="this.createQuote()">
                  Create Quote
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
